const healthConditions = [
  { value: 1, label: 'Hypertension' },
  { value: 2, label: 'Hyperlipidemia' },
  { value: 3, label: 'Arthritis' },
  { value: 4, label: 'Ischemic Heart Disease' },
  { value: 5, label: 'Diabetes' },
  { value: 6, label: 'Chronic Kidney Disease' },
  { value: 7, label: 'Depression' },
  { value: 8, label: 'Heart Failure' },
  { value: 9, label: 'COPD' },
  { value: 10, label: 'Cancer - Breast' },
  { value: 11, label: 'Cancer - Colorectal' },
  { value: 12, label: 'Cancer - Prostate' },
  { value: 13, label: 'Cancer - Lung' },
  { value: 14, label: 'Cancer - Endometrial' },
  { value: 15, label: 'Alzheimer\'s Disease/Dementia' },
  { value: 16, label: 'Atrial Fibrillation' },
  { value: 17, label: 'Osteoporosis' },
  { value: 18, label: 'Asthma' },
  { value: 19, label: 'Stroke' },
  { value: 20, label: 'Alcohol Abuse' },
  { value: 21, label: 'Drug Abuse/Substance Abuse' },
  { value: 22, label: 'Schizophrenia/Other Psychotic Disorders' },
  { value: 23, label: 'Hepatitis (Chronic Viral B & C)' },
  { value: 24, label: 'HIV/AIDS' }
]

export const getPartialList = (section) => {
  const sorted = healthConditions.sort((a, b) => a.label > b.label ? 1 : -1)
  return [...sorted].slice(section * 8, (section * 8) + 8)
}

export default healthConditions
